export const padId = (value: string | number, shift: number, hideSign?: boolean) => {
	const numberSign = hideSign ? '' : '#';
	return `${numberSign}${String(value).padStart(shift, '0')}`;
};
